import { GenIcon } from '../helpers/IconBase.es.js';

const TrashBinDeleteRemoveOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M19.0699 10.47L18.3416 19.6285C18.3114 20.0091 18.1218 20.3653 17.8108 20.6254C17.4999 20.8854 17.0907 21.03 16.6658 21.03H8.03396C7.60904 21.03 7.1999 20.8854 6.88895 20.6254C6.57799 20.3653 6.38833 20.0091 6.35816 19.6285L5.62988 10.47",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.64516 4.53595C9.66818 4.51293 9.6994 4.5 9.73195 4.5H14.9683C15.0009 4.5 15.0321 4.51293 15.0551 4.53595C15.0781 4.55896 15.091 4.59018 15.091 4.62273V6.49078H9.60922V4.62273C9.60922 4.59018 9.62215 4.55896 9.64516 4.53595ZM8.84521 7.99078C8.84987 7.99087 8.85454 7.99091 8.85922 7.99091C8.8639 7.99091 8.86857 7.99087 8.87323 7.99078H15.827C15.8317 7.99087 15.8364 7.99091 15.841 7.99091C15.8457 7.99091 15.8504 7.99087 15.855 7.99078H21.95C22.3642 7.99078 22.7 7.65499 22.7 7.24078C22.7 6.82657 22.3642 6.49078 21.95 6.49078H16.591V4.62273C16.591 4.19235 16.4201 3.77961 16.1158 3.47529C15.8114 3.17097 15.3987 3 14.9683 3H9.73195C9.30157 3 8.88882 3.17097 8.5845 3.47529C8.28018 3.77961 8.10922 4.19235 8.10922 4.62273V6.49078H2.75C2.33579 6.49078 2 6.82657 2 7.24078C2 7.65499 2.33579 7.99078 2.75 7.99078H8.84521Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { TrashBinDeleteRemoveOutlined };
